import React from 'react';
import icLoading from 'assets/svg/spinning-circles.svg';
import icLoadingSecondary from 'assets/svg/spinning-circles-second.svg';
import styles from './styles.module.scss';
import classNames from 'classnames';

const Spinner = ({
  size = 200,
  className,
  secondary
}) => {
  const src = secondary ? icLoadingSecondary : icLoading;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    className: styles.rotate,
    width: size,
    height: size,
    src: src
  }));
};

export default Spinner;